type DeltaLike = { ops?: Array<{ insert?: unknown }>; insert?: (text: string) => unknown };

function endsWithNewline(delta: DeltaLike): boolean {
  const ops = delta?.ops;
  if (!ops || ops.length === 0) return false;
  const last = ops[ops.length - 1];
  return typeof last?.insert === 'string' && last.insert.endsWith('\n');
}

function ensureTrailingNewline(delta: DeltaLike): DeltaLike {
  // Quill expects block boundaries to end with '\n'. If they don't, paragraphs can be merged.
  if (!endsWithNewline(delta) && typeof delta?.insert === 'function') {
    delta.insert('\n');
  }
  return delta;
}

/**
 * Quill clipboard.convert fix:
 * Some global CSS/layout scenarios cause Quill's default "isLine" detection
 * to fail and collapse multiple paragraphs into a single line when converting HTML.
 *
 * These matchers force a newline at the end of each <p>/<div> block.
 */
export const quillClipboardForceParagraphMatchers: Array<[string, (node: Node, delta: any) => any]> = [
  ['p', (_node, delta) => ensureTrailingNewline(delta)],
  ['div', (_node, delta) => ensureTrailingNewline(delta)],
];

